import React, { PropsWithChildren } from 'react';

import styles from './header.module.scss';

type HeaderProps = React.PropsWithChildren<{
  title?: string;
}>;

export const Header: React.FC<PropsWithChildren<HeaderProps>> = ({ title, children }) => (
  <header className={styles['header']}>
    <h1 className={styles['title']}>{title}</h1>
    <div className={styles['items']}>{children}</div>
  </header>
);
